module.exports = __webpack_public_path__ + "0b7ff120147e7b976219aa0e4f0f1d30.pdf";